import parse from 'html-react-parser';

const checkStandalone = () => {
  if(typeof navigator ===  'undefined' && typeof window === 'undefined')
  {
    return false;
  } else {
    return (navigator.standalone || window.matchMedia('(display-mode: standalone)').matches);
  }
}

const parseHTML = (string,isNoLinebreak) => {
  if(typeof string === "undefined")
    return '';

  if(isNoLinebreak)
    return parse(string);
  return parse(string.replace(/\n/g,'<br/>'));
}

const checkCookieConsent = () => {
  if(typeof window !== 'undefined' && typeof window.Osano !== 'undefined')
  {
    return { inited: true, consent : window.Osano.cm.getConsent() };
  }
  return { inited: false, consent : null };
}

const isMacSafari = () => {
  if (typeof window === 'undefined') return false;
  const userAgent = window.navigator.userAgent;
  const isMac = /Mac|iPod|iPhone|iPad/.test(userAgent);
  const isSafari = /Safari/.test(userAgent) && !/Chrome|CriOS|FxiOS/.test(userAgent);
  return isMac && isSafari;
};

const isAutoEmbedAllowed = () => {
  const cookieConsent = checkCookieConsent();
  return (cookieConsent.inited && cookieConsent.consent.ANALYTICS === "ACCEPT" && cookieConsent.consent.MARKETING === "ACCEPT");
}

export { checkStandalone, parseHTML, checkCookieConsent, isMacSafari, isAutoEmbedAllowed };
